// src/App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeView from './views/HomeView';
import ExamView from './views/ExamView';
import AllQuestionsView from './views/AllQuestionsView';
import StudyView from './views/StudyView';
import SettingsView from './views/SettingsView';
import './assets/styles/App.css';
import { SettingsProvider } from './components/Settings/SettingsContext';

function App() {
    return (
        <SettingsProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<HomeView />} />
                    <Route path="/quiz/:listId" element={<ExamView />} />
                    <Route path="/learn/:listId" element={<StudyView />} />
                    <Route path="/all-questions" element={<AllQuestionsView />} />
                    <Route path="/settings" element={<SettingsView />} />
                </Routes>
            </Router>
        </SettingsProvider>
    );
}

export default App;
